var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelfieAlbum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 298 298",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M280.042,65.545H146.673V44.191c0-8.506-6.896-15.402-15.402-15.402H68.73c-8.506,0-15.402,6.896-15.402,15.402v21.355 h-35.37C8.04,65.545,0,73.585,0,83.503v167.75c0,9.919,8.04,17.959,17.958,17.959h262.084c9.918,0,17.958-8.04,17.958-17.959 V83.503C298,73.585,289.96,65.545,280.042,65.545z M211.667,214.804c0,7.773-6.302,14.074-14.074,14.074H49.284 c-7.772,0-14.074-6.302-14.074-14.074v-94.852c0-7.772,6.302-14.074,14.074-14.074h148.309c7.772,0,14.074,6.302,14.074,14.074 V214.804z M253.948,170.867c-6.905,0-12.503-5.599-12.503-12.504c0-6.906,5.598-12.504,12.503-12.504 c6.906,0,12.505,5.598,12.505,12.504C266.453,165.269,260.855,170.867,253.948,170.867z M253.948,122.741 c-6.905,0-12.503-5.599-12.503-12.504c0-6.905,5.598-12.503,12.503-12.503c6.906,0,12.505,5.598,12.505,12.503 C266.453,117.143,260.855,122.741,253.948,122.741z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.438,175.358c-9.933,0-18.942-4.014-25.502-10.501c-5.828,6.237-9.401,14.608-9.401,23.818v22.751 c0,3.56,2.886,6.445,6.445,6.445h56.916c3.559,0,6.445-2.886,6.445-6.445v-22.751c0-9.21-3.573-17.58-9.4-23.817 C142.382,171.345,133.371,175.358,123.438,175.358z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123.438,
    cy: 139.065,
    r: 21.293
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfieAlbum);
export default __webpack_public_path__ + "static/media/selfie-album.a40b1c0dfba2c73add848a9a78541ddd.svg";
export { ForwardRef as ReactComponent };